import React from 'react'
import logo from '../../assets/revyz-logo-svg.png'
import './unauthenticated.css'
const Unauthenticated = () => {
  return (
    <div className='unauthcontainer'>
        <img src={logo} alt="revyzlogo" />
        <h1>Unauthorised access</h1>
        <p>You can contact your system administrator for more info or create a <a target="_blank" href="https://support.revyz.io/" rel="noreferrer">support ticket</a> </p>
    </div>
  )
}

export default Unauthenticated